<template>
  <div class="settings-page"> </div>
</template>

<script>
export default {
  name: 'settings-page'
};
</script>
<style scoped lang="scss"></style>
